module.exports = __webpack_public_path__ + "static/img/spinning-star.ead92e7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animated/spinning-star.gif
// module id = l7DM
// module chunks = 0